import { createAction, createSlice } from '@reduxjs/toolkit';

export const loadCategoriesRequest = createAction('categories/loadCategoriesRequest');

const initialState = {
    productCategories: [],
    productSubcategories: {},
    productModelMap: {},
    serviceRequestCategories: [],
    serviceRequestSubcategories: {},
    loading: false,
    error: null,
};

const categoriesSlice = createSlice({
    name: 'categories',
    initialState,
    reducers: {
        fetchCategoriesStart(state) {
            state.loading = true;
            state.error = null;
        },
        fetchCategoriesSuccess(state, action) {
            // console.log('action.payload', action.payload);
            state.loading = false;
            state.error = null;
            const { productCategoriesList, productSubCategoriesMap, productModelMap,
                serviceRequestCategoriesList, serviceRequestSubCategoriesMap } = action.payload;
            state.productCategories = productCategoriesList ?? [];
            state.productSubcategories = productSubCategoriesMap ?? {};
            state.productModelMap = productModelMap ?? {};
            state.serviceRequestCategories = serviceRequestCategoriesList ?? [];
            state.serviceRequestSubcategories = serviceRequestSubCategoriesMap ?? {};
        },
        fetchCategoriesFailure(state, action) {
            state.loading = false;
            state.error = action.payload;
        }
    },
});

export const { fetchCategoriesStart, fetchCategoriesSuccess, fetchCategoriesFailure } = categoriesSlice.actions;

export default categoriesSlice.reducer;